import { Menu } from "../menu/menu";
import { SearchBox } from "../search-box/search-box";
import { EventHandler } from "../../utils/event-handler";
import { onTransitionEnd, reflow } from "../../utils";
import { EVENT_CLICK } from "../../utils/events";

export class LangSwitcher {
    #SELECTOR_LANG_SWITCHER = '.lang-switcher';
    #SELECTOR_TOGGLER = `${this.#SELECTOR_LANG_SWITCHER}__toggler[aria-controls]`;

    #CLASS_NAME_LANG_SWITCHER_OPEN = 'open';
    #CLASS_NAME_TOGGLER_ACTIVE = 'active';
    #CLASS_NAME_ANIMATING = 'animating';

    static EVENT_LANG_SWITCHER_SHOW = 'lang-switcher-show';
    static EVENT_LANG_SWITCHER_SHOWN = 'lang-switcher-shown';
    static EVENT_LANG_SWITCHER_HIDE = 'lang-switcher-hide';
    static EVENT_LANG_SWITCHER_HIDDEN = 'lang-switcher-hidden';

    #toggler: HTMLElement;
    #content: HTMLElement;

    constructor() {
        this.#initElements();
        this.#initEvents();
    }

    #initElements(): void {
        this.#toggler = document.querySelector(this.#SELECTOR_TOGGLER);
        this.#content = document.getElementById(this.#toggler.getAttribute('aria-controls'));

        this.#setAriaExpanded(this.#isShown());
    }

    #initEvents(): void {
        EventHandler.on(this.#toggler, EVENT_CLICK, () => {
            this.toggle();
        });

        EventHandler.on(document, `${Menu.EVENT_MENU_SHOW} ${SearchBox.EVENT_SEARCH_BOX_SHOW}`, () => {
            this.hide();
        });
    }

    #isShown(): boolean {
        return this.#content.classList.contains(this.#CLASS_NAME_LANG_SWITCHER_OPEN);
    }

    #setAriaExpanded(isOpen: boolean): void {
        this.#toggler.setAttribute('aria-expanded', String(isOpen));
    }

    toggle(): void {
        if (this.#isShown()) {
            this.hide();
        } else {
            this.show();
        }
    }

    show(): void {
        if (this.#isShown()) {
            return;
        }

        EventHandler.trigger(this.#content, LangSwitcher.EVENT_LANG_SWITCHER_SHOW);

        this.#content.classList.add(this.#CLASS_NAME_ANIMATING);

        reflow(this.#content);

        this.#toggler.classList.add(this.#CLASS_NAME_TOGGLER_ACTIVE);

        onTransitionEnd(this.#content, () => {
            this.#content.classList.remove(this.#CLASS_NAME_ANIMATING);

            EventHandler.trigger(this.#content, LangSwitcher.EVENT_LANG_SWITCHER_SHOWN);
        });

        this.#content.classList.add(this.#CLASS_NAME_LANG_SWITCHER_OPEN);

        this.#setAriaExpanded(true);
    }

    hide(): void {
        if (!this.#isShown()) {
            return;
        }

        EventHandler.trigger(this.#content, LangSwitcher.EVENT_LANG_SWITCHER_HIDE);

        this.#content.classList.add(this.#CLASS_NAME_ANIMATING);

        this.#toggler.classList.remove(this.#CLASS_NAME_TOGGLER_ACTIVE);

        onTransitionEnd(this.#content, () => {
            this.#content.classList.remove(this.#CLASS_NAME_ANIMATING);

            EventHandler.trigger(this.#content, LangSwitcher.EVENT_LANG_SWITCHER_HIDDEN);
        });

        this.#content.classList.remove(this.#CLASS_NAME_LANG_SWITCHER_OPEN);

        this.#setAriaExpanded(false);
    }
}
